/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for LicencePlan controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetLicencePlanByIdResponse, UpdateLicencePlanRequest, GetLicencePlansResponse, GetLicencePlanSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class LicencePlanService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getLicencePlanById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetLicencePlanByIdResponse>;
    getLicencePlanById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetLicencePlanByIdResponse>>;
    getLicencePlanById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetLicencePlanByIdResponse>>;
    getLicencePlanById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicencePlan/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateLicencePlan(id: number, updateLicencePlanRequest: UpdateLicencePlanRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateLicencePlan(id: number, updateLicencePlanRequest: UpdateLicencePlanRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateLicencePlan(id: number, updateLicencePlanRequest: UpdateLicencePlanRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateLicencePlan(id: number, updateLicencePlanRequest: UpdateLicencePlanRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicencePlan/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateLicencePlanRequest, requestOptions);
    }

    getLicencePlans(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetLicencePlansResponse>;
    getLicencePlans(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetLicencePlansResponse>>;
    getLicencePlans(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetLicencePlansResponse>>;
    getLicencePlans(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicencePlan`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getLicencePlanSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetLicencePlanSelectResponse>;
    getLicencePlanSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetLicencePlanSelectResponse>>;
    getLicencePlanSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetLicencePlanSelectResponse>>;
    getLicencePlanSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/LicencePlan/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
